import { AdminModalName, HistoryStackEntry } from '../../../state';
import { AdminDeleteEventModal } from '../admin-delete-event-modal';
import { AdminDeletePageModal } from '../admin-delete-page-modal';
import { AdminDeletePlaceModal } from '../admin-delete-place-modal';
import { AdminDiscardPageDraftModal } from '../admin-discard-page-draft-modal';
import React from 'react';

export const getModal = (
  entry: HistoryStackEntry<AdminModalName>,
): React.ReactElement => {
  switch (entry.name) {
    case AdminModalName.DeleteEvent:
      return <AdminDeleteEventModal {...entry.state} />;
    case AdminModalName.DeletePlace:
      return <AdminDeletePlaceModal {...entry.state} />;
    case AdminModalName.DeletePage:
      return <AdminDeletePageModal {...entry.state} />;
    case AdminModalName.DiscardPageDraft:
      return <AdminDiscardPageDraftModal {...entry.state} />;
  }
};
